import { jsPDF } from "jspdf";
import "jspdf-autotable";

export class PDFGenerator {
  doc: jsPDF;
  readonly pageWidth = 80;
  readonly pageHeight = 297;

  readonly fontSize = 10;
  readonly lineHeight = 5;
  readonly margin = 2;
  readonly titleFontSize = 14;
  readonly subTitleFontSize = 8;
  readonly fontFamily = "Helvetica";

  constructor(options?: { height?: number }) {
    const height = options?.height || 297;
    this.doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [80, height],
      hotfixes: ["px_scaling"],
    });
  }

  public calculateTableWidth(percentage: number) {
    return (
      (this.doc.internal.pageSize.width - 2 * this.margin) * (percentage / 100)
    );
  }

  setup() {
    // Set font
    this.doc.setFont("Helvetica");
    this.doc.setFontSize(10);
  }

  getDoc() {
    return this.doc;
  }

  download(filename: string) {
    this.doc.save(filename);
  }

  print() {
    // this.doc.autoPrint();
    this.printInBrowser();
    // this.doc.
    // this.doc.autoPrint();
    // this.doc.output("bloburl");
    // window.open(this.doc.output("bloburl"), "_blank");
    // return
    // this.doc.output("dataurlstring");
  }

  printInBrowser() {
    const pdfBlob = this.doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    if (!document) {
      console.error("Document is not available.");
      return;
    }

    const iframe = document.getElementById("pdfFrame") as HTMLIFrameElement;

    if (!iframe) {
      console.error("Iframe with id 'pdfFrame' not found in the document.");
      return;
    }
    // iframe.style.display = "hidden"; // show preview
    iframe.src = pdfUrl;

    // Wait for iframe to load, then trigger print dialog
    iframe.onload = function () {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    };
  }
}
